import { useState } from 'react';
import { testimonials } from '@/mocks/articles';

const avatarUrls: Record<string, string> = {
  'avatar-01': 'https://readdy.ai/api/search-image?query=Professional%20circular%20avatar%20portrait%20of%20modern%20Chinese%20young%20adult%2C%20warm%20neutral%20tones%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20approachable%20expression%2C%20editorial%20portrait%20photography%2C%20high%20quality%20professional%20headshot%20style%2C%20simple%20elegant%20composition&width=120&height=120&seq=avatar-testimonial-01&orientation=squarish',
  'avatar-02': 'https://readdy.ai/api/search-image?query=Professional%20circular%20avatar%20portrait%20of%20Chinese%20media%20professional%20adult%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background%2C%20confident%20calm%20expression%2C%20editorial%20portrait%20photography%20style%2C%20high%20quality%20headshot%2C%20simple%20elegant%20composition%2C%20soft%20natural%20tones&width=120&height=120&seq=avatar-testimonial-02&orientation=squarish',
  'avatar-03': 'https://readdy.ai/api/search-image?query=Professional%20circular%20avatar%20portrait%20of%20young%20Chinese%20social%20media%20user%2C%20warm%20friendly%20lighting%2C%20minimal%20clean%20background%2C%20enthusiastic%20natural%20expression%2C%20modern%20portrait%20photography%2C%20high%20quality%20headshot%20style%2C%20simple%20composition%2C%20soft%20natural%20tones&width=120&height=120&seq=avatar-testimonial-03&orientation=squarish',
};

export default function Testimonial() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const goNext = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const goPrev = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="testimonial-title">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <h2 id="testimonial-title" className="font-body text-2xl md:text-3xl text-foreground-950 mb-2">
          <span className="text-foreground-400">「</span>
          用户口碑
          <span className="text-foreground-400">」</span>
        </h2>

        <div className="mt-8 md:mt-10">
          <div className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 rounded-full mb-6">
            <i className="ri-star-fill text-sm text-accent-500"></i>
            <span className="text-sm font-label font-bold text-background-50">{t.rating}.0</span>
          </div>

          <blockquote className="font-body text-lg md:text-xl text-foreground-800 leading-relaxed italic mb-8">
            &ldquo;{t.comment}&rdquo;
          </blockquote>

          <div className="flex items-center justify-center gap-3">
            <img
              src={avatarUrls[t.avatarSeq]}
              alt={t.name}
              className="w-12 h-12 rounded-full object-cover"
              loading="lazy"
            />
            <div className="text-left">
              <p className="text-sm font-label font-bold text-foreground-950">{t.name}</p>
              <p className="text-xs text-foreground-500">{t.role}</p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-3 mt-10">
          <button
            onClick={goPrev}
            className="w-10 h-10 flex items-center justify-center border border-foreground-200 rounded-lg text-foreground-700 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all duration-200 cursor-pointer"
            aria-label="上一条评价"
          >
            <i className="ri-arrow-left-line"></i>
          </button>
          <button
            onClick={goNext}
            className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            aria-label="下一条评价"
          >
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}